import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import { translateDisplayValue } from "../../utils/displayLabel";
import YuJaButton from '../../components/standardization/YuJaButton';
import classes from "../../components/FilterMenu.module.css";
import { ReactComponent as Filter } from "../../images/filter.svg";
import { ReactComponent as ARROW_RIGHT } from "../../images/arrow_right_black.svg";
import {YuJaCheckbox} from "../../components/standardization/YuJaCheckbox";
import YuJaDatePicker from "../../components/YuJaDatePicker";
import { Popover } from '@base-ui/react/popover';
import {Button} from "@base-ui/react/button";

export default function EventBannerFilter({ onApply, filterOptions, style={}}) {
    const {t} = useTranslation();
    const [optionFilter1, setOptionFilter1] = useState(filterOptions?.optionFilter1);
    const [optionFilter2, setOptionFilter2] = useState(filterOptions?.optionFilter2);
    const [optionFilter3, setOptionFilter3] = useState(filterOptions?.optionFilter3);
    const [dateFilter1, setDateFilter1] = useState(filterOptions?.dateFilter1);
    const [dateFilter2, setDateFilter2] = useState(filterOptions?.dateFilter2);
    const [total, setTotal] = useState(0);

    const popoverRef = useRef();


    const handleInputChange = (checked, event) => {
        const { name, value } = event.target;
        // console.log(name, value)
        switch (name) {
            case filterOptions?.optionFilter1Name:
                if (optionFilter1.includes(value)) {
                    setOptionFilter1(optionFilter1.filter(option => option !== value));
                } else {
                    setOptionFilter1([...optionFilter1, value]);
                }
                break;
            case filterOptions?.optionFilter2Name:
                if (optionFilter2.includes(value)) {
                    setOptionFilter2(optionFilter2.filter(option => option !== value));
                } else {
                    setOptionFilter2([...optionFilter2, value]);
                }
                break;
            case filterOptions?.optionFilter3Name:
                if (optionFilter3.includes(value)) {
                    setOptionFilter3(optionFilter3.filter(option => option !== value));
                } else {
                    setOptionFilter3([...optionFilter3, value]);
                }
                break;
            // case filterOptions?.dateFilter1Name:
            //     setDateFilter1(value);
            //     break;
            // case filterOptions?.dateFilter2Name:
            //     setDateFilter2(value);
            //     break;
            default:
                console.log('Error: Invalid filter name');
                break;
        }
    };

    const handleClear = () => {
        if (filterOptions?.optionFilter1Name) setOptionFilter1([]);
        if (filterOptions?.optionFilter2Name) setOptionFilter2([]);
        if (filterOptions?.optionFilter3Name) setOptionFilter3([]);
        if (filterOptions?.dateFilter1Name) setDateFilter1("");
        if (filterOptions?.dateFilter2Name) setDateFilter2("");
    };

    const handleApply = () => {

        onApply({
            optionFilter1: optionFilter1,
            optionFilter2: optionFilter2,
            optionFilter3: optionFilter3,
            dateFilter1: dateFilter1,
            dateFilter2: dateFilter2
        });
        close();
    };

    const close = () => {
        if (popoverRef.current) {
            popoverRef.current.close();
        }

    }


    useEffect(() => {
        let temp = 0;
        if (!!optionFilter1 && !!filterOptions?.optionsFilter1) {
            temp += optionFilter1.filter(i => filterOptions.optionsFilter1.includes(i)).length;
        }

        if (!!optionFilter2 && !!filterOptions?.optionsFilter2) {
            temp += optionFilter2.filter(i => filterOptions.optionsFilter2.includes(i)).length;
        }

        if (!!optionFilter3 && !!filterOptions?.optionsFilter3) {
            temp += optionFilter3.filter(i => filterOptions.optionsFilter3.includes(i)).length;
        }

        if (!!dateFilter1) {
            temp += 1;
        }

        if (!!dateFilter2) {
            temp += 1;
        }

        setTotal(temp);
    }, [optionFilter1, optionFilter2, optionFilter3, dateFilter1, dateFilter2, filterOptions]);

    return (

      <Popover.Root
          modal={"trap-focus"}
          actionsRef={popoverRef}
          onOpenChangeComplete={() => {
              setOptionFilter1(filterOptions?.optionFilter1);
              setOptionFilter2(filterOptions?.optionFilter2);
              setOptionFilter3(filterOptions?.optionFilter3);
              setDateFilter1(filterOptions?.dateFilter1);
              setDateFilter2(filterOptions?.dateFilter2);
          }}
      >
          <Popover.Trigger id={"filter-btn"} aria-label={t("poll.filterButtonText")} className={classes.filterIcon}>
              <Filter style={{width: 28, height: 28}}/>
              {!!total &&
                  <span className={classes.filterCounter}>{total}</span>
              }
          </Popover.Trigger>
          <Popover.Portal>
              <Popover.Positioner sideOffset={8}  side="bottom" align="start">
                  <Popover.Popup>
                      <div className={classes.filterMenu} style={style}>
                          <div className={classes.filterHeader}>
                              <span className={classes.filterCount}>Filter({total})</span>
                              <div style={{flex: 1}}/>
                              <Button className={classes.link} onClick={handleClear}>
                                  {t("questionBank.clearAllText")}
                              </Button>
                          </div>

                          <div className={classes.filterBody}>

                              {/* Option Filter 1 */}
                              {filterOptions?.optionFilter1Name &&
                                  <div className={classes.row} style={{alignItems: "start"}}>
                                      <div className={classes.filterTitle} style={{width: 80}}>
                                          {filterOptions.optionFilter1Name}
                                      </div>
                                      <div className={classes.grid}
                                           style={{rowGap: 10, columnGap: 15, width: "100%", gridTemplateColumns: "auto"}}>
                                          {filterOptions.optionsFilter1.map((option, index) => (
                                              <YuJaCheckbox
                                                  key={index}
                                                  id={`optionFilter1-${index}`}
                                                  name={filterOptions.optionFilter1Name}
                                                  label={translateDisplayValue(option)}
                                                  style={{fontSize: 14, color: "#4D4D4D"}}
                                                  onChange={handleInputChange}
                                                  value={option}
                                                  checked={optionFilter1.includes(option)}
                                                  // disabled={optionFilter2 &&
                                                  //     ((option === SURVEY && optionFilter2.includes(SCHEDULED))
                                                  //         || (option === ATTENDANCE &&
                                                  //             (optionFilter2.includes(UNFINISHED)
                                                  //                 || optionFilter2.includes(SCHEDULED)
                                                  //                 || optionFilter2.includes(SHARED_BY_QUESTION)))
                                                  //         || (isPPT && option === MERGED_MODE && optionFilter2.includes(SHARED_ENTIRELY)))
                                                  // }
                                              />
                                          ))}
                                      </div>
                                  </div>
                              }
                              <div className={classes.divider} style={{margin: "20px 0"}}/>

                              {(filterOptions?.dateFilter1Name || filterOptions?.dateFilter1Name) &&
                                  <div className={classes.row}>

                                      <div className={classes.row}>
                                          <div className={classes.filterTitle} style={{width: 80}}>{t("poll.startDateLabel")}</div>
                                          <div className={classes.row}>
                                              <YuJaDatePicker
                                                  date={dateFilter1}
                                                  onChange={value => {
                                                      if (!!value) {
                                                          setDateFilter1(value);
                                                      } else {
                                                          setDateFilter1("");
                                                      }
                                                  }}
                                              />
                                          </div>
                                      </div>
                                  </div>
                              }
                              <div className={classes.divider} style={{margin: "20px 0"}}/>

                              {(filterOptions?.dateFilter2Name || filterOptions?.dateFilter2Name) &&
                                  <div className={classes.row}>
                                      <div className={classes.row}>
                                          <div className={classes.filterTitle} style={{width: 80}}>{t("poll.endDateLabel")}</div>
                                          <div className={classes.row}>
                                              <YuJaDatePicker
                                                  date={dateFilter2}
                                                  onChange={value => {
                                                      if (!!value) {
                                                          setDateFilter2(value);
                                                      } else {
                                                          setDateFilter2("");
                                                      }
                                                  }}
                                              />
                                          </div>
                                      </div>
                                  </div>
                              }
                          </div>

                          <div className={classes.filterFooter}>
                              <YuJaButton type="secondary" size={"small"} style={{fontSize: 13}} onClick={() => close()}>
                                  {t("common.cancel")}
                              </YuJaButton>
                              <YuJaButton style={{fontSize: 13}} size={"small"} onClick={handleApply}>{t("common.apply")}</YuJaButton>
                          </div>
                      </div>
                  </Popover.Popup>
              </Popover.Positioner>
          </Popover.Portal>
      </Popover.Root>
    );
}
